module.exports = __webpack_public_path__ + "img/nav-38.6ab2f426.png";